const L = (u) => {
  const { bottom_section: p, main_navigation: D, social_links: e, top_navigation: s } = u, { links: d, right_icons: r, copyright_message: m } = p || {}, E = d, i = [];
  r == null || r.forEach((a) => {
    const { url: n } = a.image, o = {
      alt: a.alt,
      url: n,
      link: a.link
    };
    i.push(o);
  });
  const k = {
    disclaimer: m,
    link: E,
    footerImage: i
  }, g = [];
  e == null || e.forEach((a) => {
    const {
      alt: n,
      image: { url: o },
      link: { text: c }
    } = a, t = {
      alt: n,
      url: o,
      href: c
    };
    g.push({
      link: a == null ? void 0 : a.link,
      icon: t
    });
  });
  const f = [];
  s == null || s.forEach((a) => {
    const {
      alt: n,
      description: o,
      image: { url: c },
      link: t,
      title: x
    } = a, b = {
      alt: n,
      description: o,
      imageUrl: c,
      button: {
        text: t == null ? void 0 : t.text,
        target: t == null ? void 0 : t.target,
        url: t == null ? void 0 : t.url
      },
      title: x
    };
    f.push(b);
  });
  const { footer_links_group: l } = D || {}, h = [];
  return l == null || l.forEach((a) => {
    const { group_title: n, links: o } = a, c = [];
    o == null || o.forEach((t) => {
      c.push(t);
    }), h.push({
      heading: n,
      subheading: c
    });
  }), {
    footer: {
      helpingData: f,
      footerData: h,
      footerIcon: g,
      legalLink: k
    },
    componentType: "footer"
  };
};
export {
  L as default
};
//# sourceMappingURL=footerTransformer.js.map
